import React from 'react'
import ProbiddingContent from './probidding/ProbiddingContent'

const index = () => {
  return (
    <>
    <ProbiddingContent />
    </>
  )
}

export default index